import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "winterthur",
  industry: IndustryEnum.Transport,
  name: "Winterthur",
  slug: "win",
  ...colors,
};
export default config;
